import { useForm } from '@mantine/form'

export const useFilterUserOrders = () => {
  return useForm({
    mode: 'controlled',
    initialValues: {
      'page[num]': 1,
      'page[limit]': 10,
      include: 'statuses,agent,sales,user,package,payments',
      sort: '-order_date',
    },
  })
}